import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PageContext } from "../../../../Context/PageContext";
import { ApiConnectHistoricLog } from "../../../../api/LionsUserApiConect";
import HistoricIcon from "../meucadastro/img/historic.png"
import StarIcon from "../meucadastro/img/goldstar.png"
import ColorEmailIcon from "../meucadastro/img/emailcolor.png"
import TicketIcon from "../meucadastro/img/ticket.png"
import UserNotLogged from "../UserNotLogged";

function HistoricLog() {

    const { user, setPage, setIsLogged } = useContext(PageContext);

    const [historicLogList, setHistoricLogList] = useState([])
    const [dateRule, setDateRule] = useState("-")
    const [topicRule, setTopicRule] = useState(" ")

    useEffect(() => {
        let result = ApiConnectHistoricLog(user.userName)
        result.then(response => {
            if(response.status == 403 || response.status == 401) {
                setPage(<UserNotLogged />);
                setIsLogged(false);
                return;
            }
            if(response.data == false){
                setHistoricLogList([]);
                setTimeout(() => document.getElementById("Master").style.opacity = 1,300)
                return;
            }
            setTimeout(() => document.getElementById("Master").style.opacity = 1,300)
            setHistoricLogList(response.data)});     
        }
        ,[])

    return(
        <HistoricContainer id="Master">
                <TitleMaster>
                    <ColumItemHeaderIcon iconImg={HistoricIcon}/>
                    <h1>Histórico</h1>
                </TitleMaster>
                <HistoricHeader>
                    <HistoricHeaderItem>N°</HistoricHeaderItem>
                    <HistoricHeaderItem>
                        <Select onChange={(e) => setTopicRule(e.target.value)}>
                            <Option value=" ">Descrição</Option>
                            <Option value="Fez login">login</Option>
                            <Option value="Solicitou acesso VIP">Solicitou Vip</Option>
                            <Option value="Mudou a senha">Alterou Senha</Option>
                            <Option value="novo Acesso">Criou Acesso</Option>
                            <Option value="Excluiu o acesso">Excluiu Acesso</Option>
                        </Select>
                    </HistoricHeaderItem>
                    <HistoricHeaderItem>
                        <Select onChange={(e) => setDateRule(e.target.value)}>
                            <Option value="-">Data</Option>
                            <Option value="2024">2024</Option>
                            <Option value="2025">2025</Option>
                        </Select>
                        </HistoricHeaderItem>
                </HistoricHeader>

                <HistoricItemsMaster>
                    {historicLogList.map((item) => {
                        if(item.actionDescription.includes(topicRule) == false){
                            return;
                        }
                        if(item.actionDate.includes(dateRule) == false){
                            return;
                        }
                        return(
                        <HistoricItem>
                            <HistoricFieldNumber>{historicLogList.indexOf(item)} </HistoricFieldNumber>
                            
                            <HistoricField>{item.actionDescription}</HistoricField>
                            <HistoricFieldDate>{item.actionDate}</HistoricFieldDate>
                        </HistoricItem>
                        )
                    })}

                </HistoricItemsMaster>
                </HistoricContainer>

    )
}

export default HistoricLog;

const HistoricContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-height: 800px;
    margin-top: 0px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    padding: 20px 0px;
    transition: .5s ease-in-out;
    opacity: 0;
    //border: solid;

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 40px 15px;
      //border: solid 1px rgba(0,0,0, .2);
    }

`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 30px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90%;
      padding: 0 0px;
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
    //border: solid;

    
`

const HistoricHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 10px 0px;
    width: 100%;
    //border: solid;
    //background-color: rgba(0,0,0,.7);

    @media(max-width: 1000px) {
        margin-bottom: 20px;
    }

`

const HistoricHeaderItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 12pt;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    margin-right: 10px;
    border-radius: 5px;
    border: 1px solid;
    width: 150px;
    background-color: rgba(0,0,0,.7);
    color: white;

    @media(max-width: 1000px) {
    }

`

const Select = styled.select`
    border: none;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 12pt;
    transition: .3s ease-in-out;
    border-top: solid 1px rgba(0,0,0,.3);
    width: 100%;
    border: none;
    font-weight: bold;
    background-color: rgba(0,0,0,.0);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`

const Option = styled.option`
    color: white;
    background-color: rgba(0,0,0,.7);
    border: none;
`

const HistoricItemsMaster = styled.div`
    display: flex:
    flex-direction: column;
    align-items: center;
    //border: solid;
    width: 100%;
    margin-top: 30px;
    overflow: auto;
    background-color: rgba(0,0,0,.7);
    padding: 5px 0;
    border-radius: 5px;

    @media(max-width: 1000px) {
      width: 100%;
    }
`
const HistoricItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    transition: .3s ease-in-out;
    //border: solid 1px rgba(0,0,0,.3);
    border-radius: 5px;
    margin: 5px 10px;
    padding: 10px 0;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`
const HistoricFieldNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    text-align: center;
    //border: solid;
    margin: 0 10px;
    width: 30px;
    //background-color: rgba(0,0,0,.5);
    border-radius: 5px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const HistoricField = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    transition: .3s ease-in-out;
    padding: 10px 0px 10px 10px;
    text-align: center;
    //border: solid;
    margin: 0 20px;
    width: 650px;
    //background-color: rgba(0,0,0,.5);
    border-radius: 5px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const HistoricFieldDate = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    text-align: center;
    //border: solid;
    margin: 0 10px;
    width: 90px;
    //background-color: rgba(0,0,0,.5);
    border-radius: 5px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`




